/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum BovenbouwsuccesUitzondering {
    REGULIER_BOVENBOUWSUCCES = "Regulier bovenbouwsucces",
    GEEN_BOVENBOUW = "Geen bovenbouw",
    GEEN_RELEVANTE_PLAATSING = "Geen relevante plaatsing",
    GEEN_1_OKTOBERPLAATSING = "Geen 1-oktoberplaatsing",
    EXTRANEUS = "Extraneus",
    TUSSENTIJDSE_INSTROOM = "Tussentijdse instroom",
    DOORSTROOM_HOGER_ONDERWIJS_ZONDER_UITSLAG = "Doorstroom hoger onderwijs zonder uitslag",
    OVERGANG_NAAR_PRAKTIJKONDERWIJS = "Overgang naar praktijkonderwijs",
    UITSTROOM_SPECIAAL_ONDERWIJS = "Uitstroom speciaal onderwijs",
    UITGESLOTEN_VAN_ROD_COMMUNICATIE = "Uitgesloten van ROD-communicatie",
    VAVO_LEERLING = "VAVO leerling",
    INTERNATIONALE_LEERLING = "Internationale leerling",
    NIEUWKOMER = "Nieuwkomer"
}
